import { render, staticRenderFns } from "./buyBack.vue?vue&type=template&id=24c02007&scoped=true&"
import script from "./buyBack.vue?vue&type=script&lang=js&"
export * from "./buyBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c02007",
  null
  
)

export default component.exports